module.exports = __webpack_public_path__ + "img/2.4c9cf22a.png";